import { render, staticRenderFns } from "./VerCliente.vue?vue&type=template&id=c5241f4e&scoped=true&"
import script from "./VerCliente.vue?vue&type=script&lang=js&"
export * from "./VerCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5241f4e",
  null
  
)

export default component.exports